import { Component } from "react";

// Catches uncaught render errors anywhere below it. Without this, a crash
// anywhere in the tree unmounts everything and leaves a blank white page —
// this turns that into a visible, recoverable message instead.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            padding: 24,
            textAlign: "center",
            fontFamily: "Geist, system-ui, -apple-system, sans-serif",
            color: "#ffffff",
            background: "#04173a",
          }}
        >
          <h1 style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>
            Terjadi kesalahan
          </h1>
          <p style={{ fontSize: 14, color: "#9fb0d4", margin: 0, maxWidth: 360 }}>
            Halaman gagal dimuat. Coba muat ulang — kalau masih terjadi, hubungi admin.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              padding: "8px 20px",
              fontSize: 13,
              fontWeight: 600,
              color: "#04173a",
              background: "#ffe94a",
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            Muat Ulang
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
